"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMON_ENV_CONFIG = exports.ENV_CONFIG_KEYS_LIST = exports.ENV_CONFIG_KEYS = void 0;
var EnvConfigManager_1 = require("./EnvConfigManager");
exports.ENV_CONFIG_KEYS = {
    DEPLOY_ENV_NAME: "DEPLOY_ENV_NAME",
    NPM_PACKAGE_VERSION: "npm_package_version",
    NODE_ENV: "NODE_ENV",
};
exports.ENV_CONFIG_KEYS_LIST = (_a = {},
    _a[exports.ENV_CONFIG_KEYS.DEPLOY_ENV_NAME] = "",
    _a[exports.ENV_CONFIG_KEYS.NPM_PACKAGE_VERSION] = "",
    _a[exports.ENV_CONFIG_KEYS.NODE_ENV] = "",
    _a);
var COMMON_ENV_CONFIG = /** @class */ (function (_super) {
    __extends(COMMON_ENV_CONFIG, _super);
    function COMMON_ENV_CONFIG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(COMMON_ENV_CONFIG, "DEPLOY_ENV_NAME", {
        get: function () {
            return "".concat(process.env.DEPLOY_ENV_NAME);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(COMMON_ENV_CONFIG, "npm_package_version", {
        get: function () {
            return "".concat(process.env.npm_package_version);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(COMMON_ENV_CONFIG, "NODE_ENV", {
        get: function () {
            return "".concat(process.env.NODE_ENV);
        },
        enumerable: false,
        configurable: true
    });
    return COMMON_ENV_CONFIG;
}(EnvConfigManager_1.EnvConfigManager));
exports.COMMON_ENV_CONFIG = COMMON_ENV_CONFIG;
